const searchPanel = () => {
	const toggle = document.querySelector('.site-header__search-toggle');
	const panel = document.getElementById('site-search');
	if (!toggle || !panel) return;
	const setOpen = (open) => {
		panel.hidden = !open;
		toggle.setAttribute('aria-expanded', String(open));
		if (open) panel.querySelector('input[type="text"], input[type="search"]')?.focus();
	};
	toggle.addEventListener('click', () => setOpen(panel.hidden));
	document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) { setOpen(false); toggle.focus(); } });
};
export default searchPanel;
